import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import ScheduledEnrollmentReenrollmentTab from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentReenrollmentTab';
import EventReenrollmentView from 'automation-ui-enrollment/components/eventEnrollment/EventReenrollmentView';
import ReenrollmentConfig from 'automation-ui-canvas/components/enrollment/ReenrollmentConfig';
import { useQuery } from 'data-fetching-client';
import { GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH } from 'automation-ui-enrollment/queries/ReenrollmentQueries';
import { getClassicEnrollmentSettings, getIsClassicWorkflow, getSourceApp } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ReenrollmentSelect from 'automation-ui-enrollment/components/ReenrollmentSelect';
import { useHistory } from 'react-router-dom';
import UIButton from 'UIComponents/button/UIButton';
import { getEnrollmentConfigRoute } from 'automation-ui-canvas/utils/absoluteRoutingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReenrollmentReviewSection = ({
  flow
}) => {
  var _flow$enrollmentCrite, _getClassicEnrollment;
  const history = useHistory();
  const triggerType = getExistingTriggerType(flow.toHybridFlowInterface());
  const {
    associatedLists,
    flowEventFilters
  } = flow.toHybridFlowInterface();
  const existingAssociatedLists = associatedLists.filter(associatedList => associatedList.listTypes.includes('PERSISTED_RE_ENROLLMENT_LIST'));
  const reenrollmentState = useQuery(GET_RE_ENROLLMENT_FILTERS_FROM_FILTER_BRANCH, {
    skip: triggerType !== 'LIST',
    variables: {
      isClassicWorkflow: getIsClassicWorkflow(flow),
      enrollmentCriteria: !isFilterEmpty(flow === null || flow === void 0 || (_flow$enrollmentCrite = flow.enrollmentCriteria) === null || _flow$enrollmentCrite === void 0 ? void 0 : _flow$enrollmentCrite.filterBranch) ? (flow === null || flow === void 0 ? void 0 : flow.enrollmentCriteria).filterBranch : null,
      existingAssociatedLists,
      existingFlowEventFilters: flowEventFilters,
      /* @ts-expect-error mismatched service and legacy types */
      existingReEnrollmentTriggerSets: ((_getClassicEnrollment = getClassicEnrollmentSettings(flow)) === null || _getClassicEnrollment === void 0 ? void 0 : _getClassicEnrollment.reEnrollmentTriggerSets) || []
    }
  });
  const renderEnrollmentSection = () => {
    var _reenrollmentState$da, _reenrollmentState$da2;
    switch (triggerType) {
      case 'EVENT':
        return /*#__PURE__*/_jsx(EventReenrollmentView, {
          readOnly: true,
          shouldReenroll: !!flow.shouldReenroll,
          objectTypeId: flow.objectTypeId,
          setShouldReenroll: () => {}
        });
      case 'LIST':
        return /*#__PURE__*/_jsx(ReenrollmentConfig, {
          objectTypeId: flow.objectTypeId,
          reenrollmentState: (reenrollmentState === null || reenrollmentState === void 0 || (_reenrollmentState$da = reenrollmentState.data) === null || _reenrollmentState$da === void 0 || (_reenrollmentState$da = _reenrollmentState$da.getReenrollmentFiltersFromFilterBranch) === null || _reenrollmentState$da === void 0 ? void 0 : _reenrollmentState$da.reEnrollmentTriggers) || [],
          onReenrollmentStateChange: () => {},
          onShouldReenrollChange: () => {},
          readOnly: true,
          shouldReenroll: !!flow.shouldReenroll,
          numOrphanedTriggers: (reenrollmentState === null || reenrollmentState === void 0 || (_reenrollmentState$da2 = reenrollmentState.data) === null || _reenrollmentState$da2 === void 0 || (_reenrollmentState$da2 = _reenrollmentState$da2.getReenrollmentFiltersFromFilterBranch) === null || _reenrollmentState$da2 === void 0 ? void 0 : _reenrollmentState$da2.numOrphanedTriggers) || 0,
          sourceApp: getSourceApp(flow)
        });
      case 'SCHEDULE':
        return /*#__PURE__*/_jsx(ScheduledEnrollmentReenrollmentTab, {
          flowObjectTypeId: flow.objectTypeId
        });
      default:
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(ReenrollmentSelect, {
            shouldReenroll: !!flow.shouldReenroll,
            objectTypeId: flow.objectTypeId,
            readOnly: true,
            setShouldReenroll: () => {}
          })
        });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderEnrollmentSection(), /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-5",
      use: "tertiary-light",
      size: "small",
      onClick: () => {
        history.push({
          pathname: `${getEnrollmentConfigRoute({
            flow
          })}/reenrollment`,
          search: history.location.search
        });
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.enrollmentStep.enrollment.editReenrollment"
      })
    })]
  });
};
export default ReenrollmentReviewSection;